import React, { type ReactElement } from 'react';

const NoIcon = (): ReactElement => (
  <svg
    width="16px"
    height="15px"
    viewBox="0 0 16 15"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Role requirements no Icon</title>

    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" />
  </svg>
);

export default NoIcon;
